// ContactCard.jsx
import React from 'react';
import './ContactCard.css';
import Footer from "../Footer"; 

export default function ContactCard() {
  return (
        <div className="contact-main">
    <div className="contact-card">
      <img src="icons/green-logo.png" alt="contactlogo" className="contactlogo" />
      <img src="icons/text_logo.png" alt="contactlogo" className="contactlogo" />

      <p className="contact-info">
        📞 טלפון: <a href="tel:+0542001485">0542001485</a><br />
        📧 מייל: <a href="mailto:heyi.events@gmail.com">heyi.events@gmail.com</a><br />
      </p>
      <div className="social-icons">
      <a href="https://wa.me/972542001485" target="_blank" rel="noopener noreferrer" className="social-link">
      <img src="/icons/whatsapp.png" alt="WhatsApp" className="social-icon" />
      </a>
      <a href="https://www.instagram.com/heyi_events" target="_blank" rel="noopener noreferrer" className="social-link">
      <img src="/icons/instagram.png" alt="instagram" className="social-icon" />
      </a>
        {/* <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">📷 אינסטגרם</a> */}
        {/* <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">📘 פייסבוק</a> */}
      </div>
              

    </div>
    <Footer /> 
</div>
  );
}
